import { render, staticRenderFns } from "./feeDeductionAuditList.vue?vue&type=template&id=2967b2e0&scoped=true"
import script from "./feeDeductionAuditList.vue?vue&type=script&lang=js"
export * from "./feeDeductionAuditList.vue?vue&type=script&lang=js"
import style0 from "./feeDeductionAuditList.vue?vue&type=style&index=0&id=2967b2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967b2e0",
  null
  
)

export default component.exports